import { gsap, Power0 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { _breakP } from '../../js/lib/utils.js';

gsap.registerPlugin(ScrollTrigger);

export default class parallaxPhoto {
  constructor() {
    this.parallaxPhoto = document.querySelectorAll('.js-parallaxPhoto');
    this.init();
  }

  init() {
    if (this.parallaxPhoto.length === 0) return;

    this.parallaxPhoto.forEach(elm => {
      // デバイス制限のチェック
      const onlyDevice = elm.dataset.onlyDevice;
      if (onlyDevice === 'pc' && _breakP.SP) return;
      if (onlyDevice === 'sp' && !_breakP.SP) return;

      const elmImg = elm.querySelector('.photo__image');
      if (!elmImg) return;

      const parseNumeric = (value, fallback) => {
        if (value === undefined || value === null || value === '')
          return fallback;
        const parsed = parseFloat(value);
        return Number.isNaN(parsed) ? fallback : parsed;
      };

      const parseAxisValue = (value, fallback) => {
        if (value === undefined || value === null || value === '')
          return fallback;
        const trimmed = value.trim();
        return /^-?\d+(\.\d+)?$/.test(trimmed) ? parseFloat(trimmed) : trimmed;
      };

      const scaleStartNum = parseNumeric(elm.dataset.scaleStart, 1);
      const scaleEndNum = parseNumeric(elm.dataset.scaleEnd, 1);
      const yStartNum = parseAxisValue(elm.dataset.yStart, 0);
      const yEndNum = parseAxisValue(elm.dataset.yEnd, 0);
      const xStartNum = parseAxisValue(elm.dataset.xStart, 0);
      const xEndNum = parseAxisValue(elm.dataset.xEnd, 0);
      const startPoint = elm.dataset.startPoint || 'top bottom';
      const endPoint = elm.dataset.endPoint || 'bottom top';
      const scrubRaw = elm.dataset.scrub;
      let scrub = parseFloat(scrubRaw);
      if (Number.isNaN(scrub)) {
        scrub = 1;
      }
      scrub = Math.max(0.1, scrub);

      // GSAPタイムラインの作成
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: elm,
          start: startPoint,
          end: endPoint,
          scrub
          // markers: true
        }
      });

      // アニメーションの設定
      tl.fromTo(
        elmImg,
        {
          scale: scaleStartNum,
          x: xStartNum,
          y: yStartNum
        },
        {
          scale: scaleEndNum,
          x: xEndNum,
          y: yEndNum,
          ease: Power0.easeNone
        }
      );

      // 画像読み込み後にScrollTriggerをリフレッシュ
      elm.querySelectorAll('img').forEach(img => {
        const refreshScrollTrigger = () => {
          if (tl.scrollTrigger) {
            tl.scrollTrigger.refresh();
          }
        };

        if (img.complete) {
          refreshScrollTrigger();
          return;
        }

        img.addEventListener('load', refreshScrollTrigger, { once: true });
      });
    });
  }
}
